import React from 'react'

const ReleaseRack = () => {
  return (
    <div>ReleaseRack</div>
  )
}

export default ReleaseRack